/** @jsxImportSource @emotion/react */

import { memo } from "react";
import { useIntl } from "react-intl";
import { useLocation, useHistory } from "react-router-dom";

import { Menu } from "../../../components";
import { useAuth } from "../../../context/auth";
import { useModal } from "../../../context/modal";
import { authFetcher } from "../../../hooks/useAuthSWR";

const API_PATH = "/videos/inputs";
const PAGE_COUNT = 10;

interface Props {
  id: string;
  anchorEl: HTMLElement | null;
  onClickMenu: () => void;
}

const ActionMenus = ({ id, anchorEl, onClickMenu }: Props): JSX.Element => {
  const intl = useIntl();
  const location = useLocation();
  const { push } = useHistory();
  const { logout } = useAuth();
  const [showModal, hideModal] = useModal();

  const { pathname } = location;
  const open = Boolean(anchorEl);

  const handleClickMenus = () => onClickMenu();

  return (
    <Menu
      id="event-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClickMenus}
      items={[
        {
          text: intl.formatMessage({ id: "general.live" }),
          disabled: pathname === "/live/new-event",
          onClick: () => {
            push("/live/new-event", { from: pathname });
            handleClickMenus();
          },
        },
        {
          text: intl.formatMessage({ id: "general.vod-to-live" }),
          disabled: pathname === "/live/new-vod2live",
          onClick: async () => {
            try {
              const data: any = await authFetcher(API_PATH, {
                method: "get",
                logout,
                params: {
                  limit: PAGE_COUNT,
                  page: 1,
                },
              });
              if (!data?.data?.length) {
                showModal({
                  title: intl.formatMessage({
                    id: "popout-title.upload-files",
                  }),
                  content: (
                    <div css={{ margin: "0 20px 100px" }}>
                      {intl.formatMessage({
                        id: "popout-context.upload-files",
                      })}
                    </div>
                  ),
                  actions: [
                    {
                      label: intl.formatMessage({ id: "btn.skip" }),
                      color: "white",
                      style: { marginBottom: 8 },
                      onClick: () => {
                        hideModal();
                        push("/live/new-vod2live", { from: pathname });
                      },
                    },
                    {
                      label: intl.formatMessage({
                        id: "popout-title.upload-files",
                      }),
                      primary: true,
                      style: { marginBottom: 8 },
                      onClick: () => {
                        hideModal();
                        push("/live/media", { from: pathname });
                      },
                    },
                  ],
                });
              } else {
                push("/live/new-vod2live", { from: pathname });
              }
            } catch (e) {
              console.error("> Action Menus > GetMediaFiles: ", e);
            } finally {
              handleClickMenus();
            }
          },
        },
      ]}
    />
  );
};

export default memo(ActionMenus);
